"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityDetailsRouteComponent = exports.EntityDetailsRoute = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var client_1 = require("@apollo/client");
var theme_1 = require("@shapeable/theme");
var theme_2 = require("@shapeable/theme");
var layout_1 = require("../elements/layout");
var loading_layout_1 = require("../elements/loading-layout");
var use_dimensions_1 = require("../../hooks/use-dimensions");
var use_lang_1 = require("../../hooks/use-lang");
var use_entity_connections_state_1 = require("../../hooks/use-entity-connections-state");
var use_full_screen_state_1 = require("../../hooks/use-full-screen-state");
var use_icons_1 = require("../../hooks/use-icons");
var use_app_screen_1 = require("../../hooks/use-app-screen");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var seo_1 = require("../elements/seo");
var breadcrumb_navigation_1 = require("../elements/breadcrumb-navigation");
var entity_update_button_1 = require("./entity-update-button");
var sprintf_js_1 = require("sprintf-js");
var entity_details_state_context_1 = require("../context/entity-details-state-context");
var app_section_context_1 = require("../context/app-section-context");
var menu_context_1 = require("../context/menu-context");
var entity_view_navigation_1 = require("./entity-view-navigation");
var lodash_1 = require("lodash");
var entity_details_layout_1 = require("./entity-details-layout");
var icon_button_1 = require("../elements/icon-button");
var error_dialog_layout_1 = require("../elements/error-dialog-layout");
var router_1 = require("@reach/router");
var entity_conversation_route_1 = require("./entity-conversation-route");
var entity_connections_route_1 = require("./entity-connections-route");
var tab_1 = require("../elements/tab");
var tabs_1 = require("../elements/tabs");
var app_screen_layout_1 = require("../app/app-screen-layout");
var entity_image_viewer_1 = require("./entity-image-viewer");
var modal_1 = require("../elements/modal");
var entity_details_banner_1 = require("./entity-details-banner");
var entity_platform_activity_1 = require("./entity-platform-activity");
var entity_connections_summary_1 = require("./entity-connections-summary");
var details_1 = require("../elements/details");
var use_recent_list_1 = require("../../hooks/use-recent-list");
var use_entities_1 = require("../../hooks/use-entities");
var use_active_person_1 = require("../../hooks/use-active-person");
var menu_button_1 = require("../elements/menu-button");
var entity_context_1 = require("../context/entity-context");
var entity_preview_1 = require("./entity-preview");
var icons_1 = require("@shapeable/icons");
var entity_slices_1 = require("./entity-slices");
var entity_views_1 = require("./entity-views");
// -------- Styles -------->
var LayoutStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var BodyStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: 0 auto;\n    display: block;\n    width: 100%;\n  "], ["\n    margin: 0 auto;\n    display: block;\n    width: 100%;\n  "])))
});
var LoadingLayoutStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BreadcrumbNavigationStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 100%;\n    margin-top: 0px;\n  "], ["\n    width: 100%;\n    margin-top: 0px;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var UpdateButtonStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(3.5)),
  desktop: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ViewNavigationStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ConnectionsStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ConversationStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DetailsStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TabsAndDetailsStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var TabsStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TabStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    margin-top: 1px;\n    margin-right: ", ";\n    overflow-x: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  "], ["\n    margin-top: 1px;\n    margin-right: ", ";\n    overflow-x: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  "])), theme_1.theme.UNIT(1)),
  tablet: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    margin-top: 4px;\n\n    ", "\n  "], ["\n    margin-top: 4px;\n\n    ", "\n  "])), function (props) {
    return props.useCompactTabs && (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n      margin-top: 4px;\n    "], ["\n      margin-top: 4px;\n    "])));
  })
});
var ImageModalStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    z-index: 200;\n    cursor: pointer;\n  "], ["\n    z-index: 200;\n    cursor: pointer;\n  "])))
});
var ViewerStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    margin: ", ";\n    width: 100%;\n    max-width: 2368px;\n  "], ["\n    margin: ", ";\n    width: 100%;\n    max-width: 2368px;\n  "])), theme_1.theme.UNIT(8))
});
var BannerStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var PlatformActivityStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ConnectionsSummaryStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    padding: ", ";\n    border-top: 1px solid ", ";\n  "], ["\n    padding: ", ";\n    border-top: 1px solid ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.COLOR('line-mid'))
});
var MenuButtonStyles = (0, theme_2.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
// -------- Components -------->
var My = {
  Layout: (0, styled_components_1.default)(layout_1.Layout)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Body: styled_components_1.default.div(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  TabsAndDetails: styled_components_1.default.div(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), TabsAndDetailsStyles),
  Details: (0, styled_components_1.default)(details_1.Details)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), DetailsStyles),
  MenuButton: (0, styled_components_1.default)(menu_button_1.MenuButton)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), MenuButtonStyles),
  Tabs: (0, styled_components_1.default)(tabs_1.Tabs)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), TabsStyles),
  Tab: (0, styled_components_1.default)(tab_1.Tab)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), TabStyles),
  LoadingLayout: (0, styled_components_1.default)(loading_layout_1.LoadingLayout)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), LoadingLayoutStyles),
  BreadcrumbNavigation: (0, styled_components_1.default)(breadcrumb_navigation_1.BreadcrumbNavigation)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), BreadcrumbNavigationStyles),
  UpdateButton: (0, styled_components_1.default)(entity_update_button_1.EntityUpdateButton)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), UpdateButtonStyles),
  ViewNavigation: (0, styled_components_1.default)(entity_view_navigation_1.EntityViewNavigation)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), ViewNavigationStyles),
  Connections: (0, styled_components_1.default)(entity_connections_route_1.EntityConnectionsRoute)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), ConnectionsStyles),
  Conversation: (0, styled_components_1.default)(entity_conversation_route_1.EntityConversationRoute)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), ConversationStyles),
  ImageModal: (0, styled_components_1.default)(modal_1.Modal)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), ImageModalStyles),
  ImageViewer: (0, styled_components_1.default)(entity_image_viewer_1.EntityImageViewer)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), ViewerStyles),
  Preview: (0, styled_components_1.default)(entity_preview_1.EntityPreview)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Slices: (0, styled_components_1.default)(entity_slices_1.EntitySlices)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Views: (0, styled_components_1.default)(entity_views_1.EntityViews)(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  PlatformActivity: (0, styled_components_1.default)(entity_platform_activity_1.EntityPlatformActivity)(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), PlatformActivityStyles),
  ConnectionsSummary: (0, styled_components_1.default)(entity_connections_summary_1.EntityConnectionsSummary)(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), ConnectionsSummaryStyles),
  // Actions: styled(EntityActions)`${ActionsStyles}`,
  Banner: (0, styled_components_1.default)(entity_details_banner_1.EntityDetailsBanner)(templateObject_45 || (templateObject_45 = __makeTemplateObject(["", ""], ["", ""])), BannerStyles)
};
var EntityDetailsRoute = function (props) {
  var _a, _b;
  var slug = props.slug,
    context = props.context,
    entityTypeSlug = props.entityTypeSlug;
  var trailing = props['*'];
  //  const definition = useEntityDefinitionForPluralSlug(entityTypeSlug);
  var definition = (0, use_entity_definition_1.useEntityDefinition)();
  var person = (0, use_active_person_1.useActivePerson)().person;
  var useCompactTabs = person && person.useCompactTabs;
  var routeConfig = definition.details;
  var t = (0, use_lang_1.useLang)();
  var icons = (0, use_icons_1.useIcons)();
  var entities = (0, use_entities_1.useEntities)();
  var _c = (0, use_recent_list_1.useRecentList)(),
    addRecent = _c.addRecent,
    items = _c.items;
  var parts = trailing ? (0, lodash_1.filter)(trailing.split('/')) : [];
  var _d = __read((0, use_entity_connections_state_1.useEntityConnectionsState)(), 2),
    entityConnectionsState = _d[0],
    setEntityConnectionsState = _d[1];
  var _e = (0, use_full_screen_state_1.useFullScreenState)(),
    isFullScreen = _e.isFullScreen,
    isSplitScreen = _e.isSplitScreen;
  // the first route segment in the trailing is assumed to be the child route identifier
  var child = parts.length > 0 && parts[0] || '';
  var childState = parts.slice(1, parts.length).join('/');
  var depth = entityConnectionsState.depth;
  if (!routeConfig) {
    throw new Error("Route Details Configuration for Entity '".concat(definition.name, "' is missing, this item cannot be displayed"));
  }
  var details = definition.details,
    useConversation = definition.useConversation,
    useConnections = definition.useConnections,
    usePreview = definition.usePreview,
    useSlices = definition.useSlices,
    useViews = definition.useViews;
  var children = (0, use_app_screen_1.useAppScreen)().detailsChildren;
  // try to find a matching child route
  var detailsChildConfig = children.find(function (childRoute) {
    return childRoute.path === child;
  });
  var query = detailsChildConfig ? detailsChildConfig.query : routeConfig.query;
  var EntityLayout = detailsChildConfig ? detailsChildConfig.component : definition.components.details || entity_details_layout_1.EntityDetailsLayout;
  var Icons = (0, use_icons_1.useIcons)();
  var bodyRef = React.useRef();
  var menuContext = {
    portal: bodyRef,
    useEditRoute: true,
    preventDelete: true,
    extraItems: [{
      label: "View All ".concat(definition.pluralLabel),
      icon: React.createElement(Icons.ArrowLeftCircle, null),
      value: 'LISTING',
      onClick: function (event) {
        event.stopPropagation();
        event.preventDefault();
        (0, router_1.navigate)("/".concat(definition.routes.list));
      }
    }]
  };
  var entityTypeName = definition && definition.name;
  var variables = {
    id: slug
  };
  React.useEffect(function () {
    if (entityTypeName && slug) {
      addRecent({
        entityTypeName: entityTypeName,
        slug: slug
      });
    }
  }, [slug, entityTypeName]);
  // run the query
  var _f = (0, client_1.useQuery)(query, {
      variables: variables,
      errorPolicy: 'all',
      fetchPolicy: 'network-only'
    }),
    _g = _f.data,
    data = _g === void 0 ? {} : _g,
    error = _f.error,
    refetch = _f.refetch,
    loading = _f.loading;
  // perhaps allow a callback to derive the entity, but usually the field name (single entity lookup) will match the entity name
  var entity = data[definition.singleBySlugName];
  var isDetails = true;
  console.log(entity);
  var childItems = isDetails ? (0, lodash_1.sortBy)((0, lodash_1.filter)([{
    label: useCompactTabs ? entity ? (0, lodash_1.truncate)(entity.name, {
      length: 40
    }) : 'Please wait...' : 'Overview',
    // label: `Overview`,
    path: definition.to(slug),
    isActive: !child,
    order: 0,
    backLabel: (0, sprintf_js_1.sprintf)(t('View All %s'), definition.pluralLabel),
    backPath: "/".concat(definition.routes.list),
    // menu: entity && useCompactTabs && <MenuProvider value={{ ...menuContext, expandedButton: true, direction: 'down' as MenuDirection }}><EntityMenu entity={entity} /></MenuProvider>,
    icon: function () {
      var Icon = icons.Entities[definition.name] || icons.Entities[definition.aliasOf] || icons.Target;
      return React.createElement(Icon, null);
    }
  }, useSlices && ((_a = entity === null || entity === void 0 ? void 0 : entity.slices) === null || _a === void 0 ? void 0 : _a.length) && {
    label: t('Slices'),
    path: definition.to(slug, 'slices'),
    isActive: child === 'slices',
    icon: icons_1.SliceIconGlyph,
    iconSize: 20,
    order: 50
  }, useViews && ((_b = entity === null || entity === void 0 ? void 0 : entity.views) === null || _b === void 0 ? void 0 : _b.length) && {
    label: t('Views'),
    path: definition.to(slug, 'views'),
    isActive: child === 'views',
    icon: icons_1.LayoutIconGlyph,
    iconSize: 20,
    order: 51
  }, usePreview && {
    label: t('Preview'),
    path: definition.to(slug, 'preview'),
    isActive: child === 'preview',
    icon: icons_1.FeedEntryIconGlyph,
    iconSize: 16,
    order: 54
  }, useConversation && {
    label: entityTypeName === 'Person' ? t('Conversation Wall') : t('Conversation'),
    path: definition.to(slug, 'conversation'),
    isActive: child === 'conversation',
    icon: Icons.ChatLinesCircle,
    order: 100
  }, useConnections && {
    label: t('Connections'),
    path: definition.to(slug, 'connections'),
    isActive: child === 'connections',
    icon: Icons.AppSections.Connections,
    order: 200
  }]), 'order') : [];
  var appSection = definition.appSection;
  // find the appSection child which is a list on this entity - breadcrumbs for details pages show lists
  var appSectionChild = appSection.children.find(function (item) {
    return (0, lodash_1.includes)(['list', 'list-expandable'], item.type) && item.entityTypeName === definition.name;
  });
  var effectiveChild = isFullScreen && child === 'connections' ? '' : child;
  var activeChildItem = childItems.find(function (item) {
    return item.isActive;
  });
  var screen = (0, use_app_screen_1.useAppScreen)();
  var _h = __read((0, use_dimensions_1.useDimensions)(), 2),
    tabsRef = _h[0],
    tabsInfo = _h[1];
  var state = {
    data: data,
    error: error,
    loading: loading,
    entity: entity,
    entityTypeName: definition.name,
    child: effectiveChild,
    childState: childState,
    childConfig: detailsChildConfig
  };
  var button = React.createElement(icon_button_1.IconButton, {
    to: '/',
    icon: React.createElement(icons.ChevronLeftCircle, null)
  }, t('Return to Home Page'));
  if (error) {
    return React.createElement(error_dialog_layout_1.ErrorDialogLayout, {
      button: button,
      error: error
    });
  }
  // -- this may need revising if anything else can be placed after the filter
  // const filterStateMatches = childState.match(/\:\/(.+)/);
  state.paramState = childState; // filterStateMatches && filterStateMatches.length === 2 && filterStateMatches[1];
  state.baseRoute = "".concat(entity && definition.to(entity.slug, child), "/");
  if (!loading && !entity) {
    // redirect to the list if not found
    (0, router_1.navigate)(definition.toList());
    return null;
  }
  var activeChild = screen.detailsChild || {};
  var badge = entity && entity.isDraft && t('Draft');
  var connections = React.createElement(My.Connections, {
    slug: slug
  });
  var availableHeightDelta = tabsInfo && tabsInfo.height || 0;
  var scrollDetails = !(0, lodash_1.includes)(['connections', 'conversation'], effectiveChild);
  var Banner = definition.components.banner || My.Banner;
  var ActiveChildComponent = child && activeChild.type === 'component' && activeChild.component;
  var hasActiveChildComponent = !!ActiveChildComponent;
  var detailsFragment = loading && child !== 'connections' ? React.createElement(My.LoadingLayout, null, t(routeConfig.loadingLabel || 'Please wait...')) : React.createElement(My.TabsAndDetails, null, React.createElement(My.Tabs, {
    ref: tabsRef,
    items: childItems.map(function (childItem) {
      return React.createElement(My.Tab, {
        iconSize: childItem.iconSize,
        useCompactTabs: useCompactTabs,
        backLabel: childItem.backLabel,
        backPath: childItem.backPath,
        menu: childItem.menu,
        icon: childItem.icon,
        isCurrent: childItem.isActive,
        to: childItem.path,
        key: childItem.path
      }, childItem.label);
    })
  }), React.createElement(My.Details, {
    pad: scrollDetails,
    overflow: !scrollDetails ? 'hidden' : 'auto'
  }, !child && React.createElement(React.Fragment, null, React.createElement(EntityLayout, {
    banner: React.createElement(menu_context_1.MenuProvider, {
      value: __assign({}, menuContext)
    }, React.createElement(Banner, {
      entityTypeName: definition.name,
      entity: entity,
      size: "large"
    })),
    childState: childState,
    child: effectiveChild,
    trailing: trailing,
    context: context,
    entity: entity
  })), child === 'slices' && React.createElement(My.Slices, {
    entity: entity
  }), child === 'views' && React.createElement(My.Views, {
    entity: entity
  }), child === 'preview' && React.createElement(My.Preview, {
    entity: entity
  }), child === 'conversation' && React.createElement(My.Conversation, {
    entity: entity
  }), child === 'connections' && connections, child && activeChild.type === 'platform-activity' && React.createElement(My.PlatformActivity, {
    entity: entity
  }), hasActiveChildComponent && React.createElement(React.Fragment, null, React.createElement(Banner, {
    showFollowControls: false,
    subTitle: activeChild.label,
    showDescription: false,
    size: "small",
    entity: entity
  }), React.createElement(ActiveChildComponent, {
    entity: entity
  }))));
  return React.createElement(app_section_context_1.AppSectionProvider, {
    value: {
      appSection: appSection,
      appSectionChild: appSectionChild
    }
  }, React.createElement(entity_context_1.EntityProvider, {
    value: entity
  }, React.createElement(entity_details_state_context_1.EntityDetailsStateProvider, {
    value: state
  }, React.createElement(seo_1.Seo, {
    title: entity && entity.name,
    openGraph: entity && entity.openGraph
  }), React.createElement(app_screen_layout_1.AppScreenLayout, {
    availableHeightDelta: availableHeightDelta,
    header: React.createElement(My.BreadcrumbNavigation, {
      depth: 'details',
      entity: entity,
      badge: badge,
      appSectionChild: appSectionChild,
      controls: entity && React.createElement(My.ViewNavigation, {
        child: effectiveChild,
        entity: entity
      })
    })
  }, React.createElement(My.Body, {
    ref: bodyRef
  }, detailsFragment)))));
};
exports.EntityDetailsRoute = EntityDetailsRoute;
var entityDetailsRouteComponent = function (definition) {
  return function (props) {
    return React.createElement(exports.EntityDetailsRoute, __assign({
      definition: definition
    }, props));
  };
};
exports.entityDetailsRouteComponent = entityDetailsRouteComponent;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45;